module.exports = __webpack_public_path__ + "img/icon-web-arrow-b7a333e7.svg";